import _ from "lodash";
import api from "@/api";

export default {
  namespaced: true,
  state: {
    states: [],
    codes_and_conditions_data: [],
    codes_and_conditions_meta: {},
    selected_code_and_conditions_id: null,
    show_import_excel_csv_dialog: false,
    search_text: "",
    fetching_data: false,
    filters: {
      county: null,
      state: null,
      city: null
    }
  },
  getters: {
    is_filters_has_value: state => {
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(state.filters)) {
        if (value) {
          return true;
        }
      }

      return false;
    }
  },
  mutations: {
    SET_STATES: (state, payload) => (state.states = payload),
    SET_CODES_AND_CONDITIONS_DATAS: (state, payload) => {
      state.codes_and_conditions_data = payload.data;
      state.codes_and_conditions_meta = payload.meta;
      state.fetching_data = false;
    },
    SET_SEARCH_TEXT: (state, payload) => (state.search_text = payload),
    SET_FETCHING_DATA: (state, payload) => (state.fetching_data = payload),
    SET_FILTERS: (state, payload) => (state.filters = payload),
    CLEAR_FILTERS_SEARCH: state => {
      state.term = "";
      state.filters = {
        county: null,
        state: null,
        city: null
      };
    }
  },
  actions: {
    getCodesAndConditions: async ({ state, commit }, page) => {
      commit("SET_FETCHING_DATA", true);

      const params = {
        page: page,
        ...state.filters,
        term: state.search_text
      };

      const result = await api.get("/codes-and-conditions", { params });
      const data = _.get(result, "data.result", []);

      commit("SET_CODES_AND_CONDITIONS_DATAS", data);
    }
  }
};
